import React from "react";
import { Helmet } from "react-helmet-async";
import { Phone, MapPin, Clock, Instagram } from "lucide-react";

const Contacts = () => {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28" data-testid="contacts-page">
      <Helmet>
        <title>Контакты — Ишеевские пироги, доставка по Ульяновску | +7 937 876-45-37</title>
        <meta name="description" content="Звоните: +7 937 876-45-37. Принимаем заказы ежедневно с 9:00 до 21:00. Доставка домашних пирогов по Ульяновску и Ульяновской области." />
        <link rel="canonical" href="https://pirogi73.ru/kontakty/" />
        <meta property="og:title" content="Контакты | Ишеевские пироги — доставка по Ульяновску" />
        <meta property="og:description" content="+7 937 876-45-37. Ежедневно с 9:00 до 21:00. Доставка пирогов по Ульяновску и области." />
        <meta property="og:url" content="https://pirogi73.ru/kontakty/" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "@id": "https://pirogi73.ru/#business",
          "name": "Ишеевские пироги",
          "url": "https://pirogi73.ru",
          "telephone": "+79378764537",
          "priceRange": "₽₽",
          "servesCuisine": "Русская выпечка",
          "foundingDate": "1995",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Ульяновск",
            "addressRegion": "Ульяновская область",
            "addressCountry": "RU"
          },
          "areaServed": { "@type": "City", "name": "Ульяновск" },
          "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
            "opens": "09:00",
            "closes": "21:00"
          },
          "sameAs": [
            "https://vk.com/pirogi_pirogki_73",
            "https://ok.ru/profile/578918939574"
          ]
        })}</script>
      </Helmet>

      <div className="label-eyebrow mb-4">Контакты</div>
      <h1 className="font-display text-5xl sm:text-6xl text-[#2C2520] leading-tight mb-12">
        Позвоните
        <br />
        и закажите
      </h1>

      <div className="grid md:grid-cols-2 gap-6">
        <a
          href="tel:+79378764537"
          className="block bg-white border border-[#E8E3DA] rounded-[28px] p-10 card-hover"
          data-testid="contact-phone"
        >
          <div className="w-14 h-14 rounded-full bg-[#C65D3B] text-white flex items-center justify-center mb-6">
            <Phone size={22} />
          </div>
          <div className="label-eyebrow mb-2">Телефон для заказов</div>
          <div className="font-display text-3xl text-[#2C2520]">+7 937 876-45-37</div>
          <div className="text-sm text-[#5C4F45] mt-2">Ежедневно с 09:00 до 21:00 — звоните, ответим сразу</div>
        </a>

        <div className="bg-white border border-[#E8E3DA] rounded-[28px] p-10">
          <div className="w-14 h-14 rounded-full bg-[#F2EBE1] text-[#C65D3B] flex items-center justify-center mb-6">
            <Clock size={22} />
          </div>
          <div className="label-eyebrow mb-2">Режим работы</div>
          <div className="font-display text-2xl text-[#2C2520] leading-tight">
            Без перерывов и выходных
            <br />
            с 9:00 до 21:00
          </div>
          <p className="text-sm text-[#5C4F45] mt-3">
            Заказ лучше оформлять за 2–3 часа до нужного времени
          </p>
        </div>

        <div className="bg-white border border-[#E8E3DA] rounded-[28px] p-10">
          <div className="w-14 h-14 rounded-full bg-[#F2EBE1] text-[#C65D3B] flex items-center justify-center mb-6">
            <MapPin size={22} />
          </div>
          <div className="label-eyebrow mb-2">Доставка</div>
          <div className="font-display text-2xl text-[#2C2520] leading-tight">
            Ульяновск
            <br />и Ульяновская область
          </div>
          <div className="mt-4 flex flex-wrap gap-2">
            {["Ленинский", "Засвияжский", "Железнодорожный", "Заволжский", "Новый Город"].map((d) => (
              <span key={d} className="text-xs bg-[#F2EBE1] rounded-full px-3 py-1 text-[#5C4F45]">{d}</span>
            ))}
          </div>
        </div>

        <div className="bg-white border border-[#E8E3DA] rounded-[28px] p-10">
          <div className="label-eyebrow mb-4">Мы в соцсетях</div>
          <p className="text-sm text-[#5C4F45] mb-5">Фото выпечки, акции и отзывы клиентов</p>
          <div className="flex items-center gap-3">
            <a
              href="https://vk.com/pirogi_pirogki_73"
              target="_blank"
              rel="noreferrer"
              className="flex-1 inline-flex items-center justify-center gap-2 py-3 rounded-full border border-[#E8E3DA] hover:border-[#C65D3B] transition-colors text-[#2C2520] font-bold text-sm"
              data-testid="contact-vk"
            >
              ВКонтакте
            </a>
            <a
              href="https://ok.ru/profile/578918939574"
              target="_blank"
              rel="noreferrer"
              className="flex-1 inline-flex items-center justify-center gap-2 py-3 rounded-full border border-[#E8E3DA] hover:border-[#C65D3B] transition-colors text-[#2C2520] font-bold text-sm"
              data-testid="contact-ok"
            >
              Одноклассники
            </a>
            <a
              href="https://www.instagram.com/pirogi_torty_73"
              target="_blank"
              rel="noreferrer"
              className="flex-1 inline-flex items-center justify-center gap-2 py-3 rounded-full border border-[#E8E3DA] hover:border-[#C65D3B] transition-colors text-[#2C2520]"
              data-testid="contact-instagram"
            >
              <Instagram size={16} /> Instagram
            </a>
          </div>
        </div>
      </div>

      <div className="mt-16 p-10 bg-[#2C2520] text-[#F2EBE1] rounded-[28px] text-center">
        <div className="label-eyebrow text-[#C65D3B] mb-3">Заказ по телефону</div>
        <p className="font-display text-3xl mb-2 leading-tight">Позвоните — и мы испечём для вас</p>
        <p className="text-[#C9BFB1] mb-8 text-sm">Приём заказов ежедневно с 9:00 до 21:00</p>
        <a
          href="tel:+79378764537"
          className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#C65D3B] hover:bg-[#A54C2F] transition-colors font-medium"
          data-testid="contacts-cta-call"
        >
          <Phone size={18} />
          +7 937 876-45-37
        </a>
      </div>
    </div>
  );
};

export default Contacts;
